import type { RadioGroupProps } from '@launchpad-ui/components';
import { RadioGroup as LaunchpadRadioGroup } from '@launchpad-ui/components';

import { useFieldContext } from '../../contexts';

export function RadioGroup(props: RadioGroupProps) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && field.state.meta.isDirty && field.state.meta.errors.length > 0;
  return (
    <LaunchpadRadioGroup
      isInvalid={isInvalid}
      value={field.state.value}
      onChange={(val: string) => {
        field.handleChange(val);
      }}
      onBlur={() => {
        field.handleBlur();
      }}
      {...props}
    />
  );
}
